$(document).on('submit', '#new_user', function (e) {
  if ($(this).attr('action') == "/users/sign_in") {
    e.preventDefault()
    $.ajax({
      url: $(this).attr('action'),
      method: "POST",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: $(this).serialize(),
      dataType: "json",
      success: function (data) {
      },
      error: function (jqXHR) {
      },
      complete: function (jqXHR) {
        if (jqXHR.status == 200) {
          window.location.reload()
        } else {
          let message = ""

          if (!jqXHR.responseJSON){
            alert('Login gagal')
            window.location.reload()
            return
          }

          if (jqXHR.responseJSON.message) {
            message = jqXHR.responseJSON.message
          } else if (jqXHR.responseJSON.error) {
            message = jqXHR.responseJSON.error
          } else {
            alert('Login gagal')
            window.location.reload()
            return
          }

          alert('Login gagal: ' + message)
          window.location.reload()
        }
      }
    })
  } else {

  }
})

$(document).on('submit', 'form', function (e) {
  $('.number-mask').each(function (idx, elm) {
    $(elm).val($(elm).val().split(",").join(''))
  })

  const $dom = $(this)

  $dom.find('button[type="submit"]').attr('disabled', 'disabled')
  $('#btn-submit-check-up').attr('disabled', 'disabled')
  $('#btn-submit-invoice-claim').attr('disabled', 'disabled')
  e.preventDefault()
  $dom.find("input[type='submit']").attr('disabled', 'disabled')
  const method = ($("input[name='_method']").val() == 'patch' ? "patch" : "post");
  $.ajax({
    url: $dom.attr('action'),
    method: method,
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    data: $dom.serialize(),
    dataType: "json",
    success: function (data) {
      // $('.offcanvas-end').removeClass("show")
      // $('.offcanvas-backdrop').removeClass("show")
      // $('.modal-backdrop').remove()
      $('body').removeAttr('style')
      $('body').removeAttr('class')
      loadPage({url: data.redirect_url, page_replace: true})
      Notiflix.Notify.success(data.message, {useIcon: false, position: 'right-bottom'});
      // if ($dom.closest('.offcanvas') != undefined) {
      //   $dom.closest('.offcanvas').find('.offcanvas-header').find('.btn-close').click()
      // }
      // $('#offcanvas-end').html('')
    },
    error: function (jqXHR) {
      console.log(jqXHR)
      Notiflix.Notify.failure(jqXHR.responseJSON.message, {useIcon: false, position: 'right-bottom'});

      $dom.find('input[type="submit"]').removeAttr('disabled')
      $dom.find('button[type="submit"]').removeAttr('disabled')
      $('#btn-submit-check-up').removeAttr('disabled')
      $('#btn-submit-invoice-claim').removeAttr('disabled')
    },
    complete: function (res) {
      console.log(res)
    }
  })
})


window.disableForm = function (elm) {
  $(elm).closest('form').find('input:not(.do-not-disable)').each(function () {
    $(this).attr('disabled', 'disabled')
  })
  $(elm).closest('form').find('select:not(.do-not-disable)').each(function () {
    $(this).attr('disabled', 'disabled')
  })
  $(elm).closest('form').find('textarea:not(.do-not-disable)').each(function () {
    $(this).attr('disabled', 'disabled')
  })
  $(elm).closest('div').attr('hidden', 'hidden')
  $('.btn-submit-form').closest('div').attr('hidden', 'hidden')
  $('.btn-edit-form').closest('div').removeAttr('hidden')
  $('.btn-back-form').closest('div').removeAttr('hidden')
}


window.enableForm = function (elm) {
  $(elm).closest('form').find('input:not(.do-not-enable)').each(function () {
    $(this).removeAttr('disabled')
  })
  $(elm).closest('form').find('select:not(.do-not-enable)').each(function () {
    $(this).removeAttr('disabled')
  })
  $(elm).closest('form').find('textarea:not(.do-not-enable)').each(function () {
    $(this).removeAttr('disabled')
  })
  $(elm).closest('div').attr('hidden', 'hidden')
  $('.btn-submit-form').closest('div').removeAttr('hidden')
  $('.btn-cancel-edit-form').closest('div').removeAttr('hidden')
  $('.btn-back-form').closest('div').attr('hidden', 'hidden')
}

window.suspendRecord = function (elm, text, confirmText, record_id = null) {
  Swal.fire({
    text: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: 'Batal',
    customClass: {
      confirmButton: 'btn btn-danger me-3',
      cancelButton: 'btn btn-secondary'
    },
    buttonsStyling: false
  }).then(function (result) {
    if (result.value) {
      const url = $(elm).closest('.tab-pane').attr('id').split("-----")[0].substr(4)
      $(elm).attr('disabled', 'disabled')
      $.ajax({
        url: url,
        method: "DELETE",
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        success: function (res) {
          Notiflix.Notify.success(res.message, {useIcon: false, position: 'right-bottom'});
          loadPage({url: url, page_replace: true})
        },
        error: function (jqXHR) {
          $(elm).removeAttr('disabled')
          Notiflix.Notify.failure(jqXHR.responseJSON.message, {useIcon: false, position: 'right-bottom'});
        }
      })
    }
  });
}

window.activateRecord = function (elm, text, confirmText) {
  Swal.fire({
    text: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: 'Batal',
    customClass: {
      confirmButton: 'btn btn-success me-3',
      cancelButton: 'btn btn-secondary'
    },
    buttonsStyling: false
  }).then(function (result) {
    if (result.value) {
      $(elm).attr('disabled', 'disabled')
      const url = $(elm).closest('.tab-pane').attr('id').split("-----")[0].substr(4)
      $.ajax({
        url: url + "/reactive",
        method: "PATCH",
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        success: function (res) {
          Notiflix.Notify.success(res.message, {useIcon: false, position: 'right-bottom'});
          loadPage({url: url, page_replace: true})
        },
        error: function (jqXHR) {
          $(elm).removeAttr('disabled')
          Notiflix.Notify.failure(jqXHR.responseJSON.message, {useIcon: false, position: 'right-bottom'});
        }
      })
    }
  });
}